import Refresh from "@mui/icons-material/Refresh";

import { makeSvgIcon } from "./svg-icon";

export const RefreshIcon = makeSvgIcon(Refresh);

export default RefreshIcon;
